DownloadCtrl.$inject = ['$scope', '$window', 'os', 'AnalyticsServ'];

export default function DownloadCtrl($scope, $window, os, AnalyticsServ) {

    $scope.trackDownload = function () {

        AnalyticsServ.analytics.track('Desktop App Downloaded');

        AnalyticsServ.analytics.identify({
            'Desktop App Downloaded': new Date().toUTCString()
        });
    };

    $scope.os = os;

    $scope.showDeveloperHelp = () => {
        $scope.developerHelpVisible = true;
    }

    var isStaging = $window.location.hostname.indexOf('staging') === 0;

    // file path map to download in production or staging folder
    var paths = {
        mac: 'FactBox-64.zip',
        windows: 'FactBox-Setup.exe'
    };

    // path is appended to a link to the s3 bucket on the download page
    // which is displayed if the os is mac or windows
    if (os === 'mac' || os === 'windows') {
        $scope.path = (isStaging ? 'staging' : 'production') + '/' +
            paths[os];
    }


}



// WEBPACK FOOTER //
// ./project/pages/download/download.controller.js